import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { Parallax } from 'react-scroll-parallax';
import { Wrapper, colors, media } from './style';
import Work from './Work';
import Partners from './Partners';

const Title = styled.h1`
  background-image: linear-gradient(
    to right,
    ${colors.red} 0%,
    ${colors.blue} 80.66%,
    ${colors.blue} 100%
  );
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  font-family: Roboto;
  line-height: normal;
  font-size: 37px;
  margin: 0;
  ${media.desktop`
    line-height: 120px;
    font-size: 100px;
    width: 1100px;
  `};
`;

const SubTitle = styled(Title)`
  font-family: Ubuntu Mono;
  font-style: normal;
  font-weight: normal;
  line-height: 46px;
  font-size: 41px;
  ${media.desktop`
    line-height: 120px;
    font-size: 110px;
    width: 1100px;
  `};
`;

const SecondTitle = styled.svg`
  margin: 0 -5px;
  padding-top: 62px;
  width: 100%;
  ${media.desktop`
    width: 312px;
    padding-top: 0;
    position: absolute;
    top: 130px;
    left: 41px;
  `};
`;

const WrapperLabs = styled(Wrapper)`
  position: relative;
  padding-top: 45px;
  padding-bottom: 40px;
  ${media.desktop`
    padding-top: 175px;
    padding-bottom: 118px;
  `};
  .row {
    display: flex;
    flex-direction: row;
  }
  .work {
    display: none;
    position: relative;
    ${media.desktop`
      display: block;
    `};
  }
  .work .brain {
    position: absolute;
    top: -70px;
  }
  .flag {
    position: absolute;
    right: 0;
    top: 180px;
  }
`;

const LanguageWrapper = styled.div`
  font-family: Ubuntu Mono;
  font-style: normal;
  font-weight: normal;
  line-height: 15px;
  font-size: 11px;
  text-transform: uppercase;
  a {
    text-decoration: none;
    color: ${colors.blue};
  }
  span.active {
    color: ${colors.white};
    font-weight: bold;
  }
  ${media.desktop`
    line-height: 25px;
    font-size: 16px;
    position: absolute;
    top: 530px;
    left: 41px;
  `};
`;

const Language = ({ locale }) => (
  <LanguageWrapper>
    {locale === 'en' ? (
      <React.Fragment>
        мы говорим <Link to="/ru">по-русски</Link> // <span className="active">english</span>
      </React.Fragment>
    ) : (
      <React.Fragment>
        we speak <Link to="/en">english</Link> // <span className="active">русский</span>
      </React.Fragment>
    )}
  </LanguageWrapper>
);

const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 10px;
  ${media.desktop`
    display: none;
  `};
`;

const Column = styled.div`
  flex: 1;
  font-family: Ubuntu Mono;
  font-style: normal;
  line-height: 15px;
  font-size: 11px;
  text-transform: uppercase;
  a {
    color: ${colors.white};
    text-decoration: none;
  }
`;

const ColumnMobile = styled.div`
  display: none;
  font-family: Ubuntu Mono;
  font-style: normal;
  line-height: 25px;
  font-size: 16px;
  text-transform: uppercase;
  b {
    font-size: 15px;
  }
  a {
    color: ${colors.white};
    text-decoration: none;
  }
  ${media.desktop`
    display: block;
    position: absolute;
    top: ${p => (p.second ? 410 : 290)}px;
    left: 41px;
  `};
`;

const Paragraph = styled.div`
  padding-top: 15px;
  font-family: Roboto;
  font-weight: 300;
  line-height: 20px;
  font-size: 17px;
  :first-child {
    padding-top: 35px;
  }
  ${media.desktop`
    line-height: 50px;
    font-size: 44px;
    font-weight: light;
    padding-top: 35px;
    :first-child {
      padding-top: 13px;
    }
  `};
`;

export default class Labs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offsetYMin: 0,
    };
    this.left = React.createRef();
    this.right = React.createRef();
  }

  componentDidMount() {
    this.setState({
      offsetYMin:
        this.left.current.getBoundingClientRect().height
        - this.right.current.getBoundingClientRect().height + 80,
    });
  }

  render() {
    const {
      data: {
        title, contacts, subtitle, paragraphs, partners, allPartners,
      },
      locale,
      work,
    } = this.props;
    return (
      <WrapperLabs id="labs">
        <Title dangerouslySetInnerHTML={{ __html: title }} />
        <SubTitle>{subtitle}</SubTitle>
        <SecondTitle viewBox="0 0 288 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.32 26L0.72 2.312C0.648 1.592 1.224 0.943999 1.872 0.943999H17.496C17.964 0.943999 18.396 1.232 18.576 1.7L23.616 14.156C23.796 14.624 23.688 15.164 23.292 15.488C22.932 15.812 22.356 15.848 21.924 15.596L3.456 4.58L6.624 25.64L4.32 26ZM5.832 3.284L20.16 11.816L16.704 3.284H5.832ZM31.3104 26C30.9144 26 30.5544 25.784 30.3384 25.46L25.2984 17.864C25.0824 17.504 25.0464 17.036 25.2624 16.676L33.9744 1.556C34.1544 1.16 34.5504 0.943999 34.9824 0.943999H43.5144C43.8744 0.943999 44.1984 1.088 44.4144 1.376L53.1264 11.636C53.4144 11.96 53.4864 12.428 53.3064 12.824L48.3024 25.28C48.1224 25.748 47.7264 26.036 47.2224 26.036L31.3104 26ZM27.6744 17.216L31.9584 23.66H46.4304L50.8944 12.608L42.9744 3.284H35.6664L27.6744 17.216ZM65.1566 26H62.8166V5.948L55.6166 3.212C55.1126 3.032 54.7886 2.492 54.8966 1.916C55.0046 1.376 55.4726 0.943999 56.0486 0.943999H73.1126V3.284H62.4206L64.4006 4.04C64.8686 4.22 65.1566 4.652 65.1566 5.156V26ZM74.5481 9.296L75.3401 8.864L80.2001 1.448C80.4161 1.124 80.7761 0.907999 81.1721 0.907999L97.0841 0.943999C97.5881 0.943999 98.0201 1.232 98.2001 1.664L103.168 14.192C103.564 15.056 102.628 15.92 101.872 15.776L78.4361 11.348L85.5281 23.66H94.5641V26H84.8441C84.4121 26 84.0161 25.784 83.8361 25.424L74.5481 9.296ZM78.1121 8.936L100.216 13.076L96.2921 3.284L81.8201 3.248L78.1121 8.936ZM104.712 13.076L105.144 10.772L111.912 12.032L113.784 0.475998L116.124 0.872L114.216 12.5L124.152 14.372L121.992 0.872L124.296 0.512L126.6 14.804L133.368 16.1L132.936 18.404L126.996 17.288L128.328 25.676L126.024 26.036L124.548 16.82L113.856 14.804L112.02 26.036L109.716 25.64L111.552 14.372L104.712 13.076ZM141.034 25.388C140.602 26.324 139.198 26.288 138.874 25.316L134.878 14.984C134.554 14.192 135.202 13.4 135.958 13.4H143.734L148.954 1.556C149.458 0.475998 150.898 0.692 151.15 1.7L154.246 13.4H159.502C160.294 13.4 160.834 14.156 160.618 14.912L157.162 25.172C156.838 26.252 155.254 26.216 154.93 25.1L152.446 15.74H145.282L141.034 25.388ZM137.686 15.74L140.026 21.824L142.726 15.74H137.686ZM154.858 15.74L156.19 20.744L157.882 15.74H154.858ZM146.29 13.4H151.834L149.746 5.552L146.29 13.4ZM200.132 26H183.032C182.168 26 181.592 25.064 182.024 24.272L194.588 0.943999L196.568 2.168L184.976 23.66H200.132V26ZM207.796 25.388C207.364 26.324 205.96 26.288 205.636 25.316L201.64 14.984C201.316 14.192 201.964 13.4 202.72 13.4H210.496L215.716 1.556C216.22 0.475998 217.66 0.692 217.912 1.7L221.008 13.4H226.264C227.056 13.4 227.596 14.156 227.38 14.912L223.924 25.172C223.6 26.252 222.016 26.216 221.692 25.1L219.208 15.74H212.044L207.796 25.388ZM204.448 15.74L206.788 21.824L209.488 15.74H204.448ZM221.62 15.74L222.952 20.744L224.644 15.74H221.62ZM213.052 13.4H218.596L216.508 5.552L213.052 13.4ZM235.041 26C234.645 26 234.285 25.784 234.069 25.46L229.029 17.792C228.813 17.432 228.777 16.964 228.993 16.604L237.669 1.556C237.885 1.16 238.281 0.943999 238.713 0.943999H247.245C247.893 0.943999 248.433 1.484 248.433 2.132V12.464L255.741 11.132C256.641 10.952 257.397 11.852 257.037 12.716L252.033 25.244C251.853 25.712 251.421 26 250.953 26H235.041ZM231.909 17.9L235.653 23.66H250.161L254.085 13.832L231.909 17.9ZM239.397 3.284L232.341 15.452L246.093 12.896V3.284H239.397ZM259.923 13.436C259.023 13.292 258.663 12.212 259.239 11.528L267.951 1.376C268.167 1.088 268.491 0.943999 268.851 0.943999H278.571L278.535 3.284H269.391L262.299 11.492L286.275 16.028C287.139 16.172 287.463 17.144 287.031 17.792L282.027 25.46C281.811 25.784 281.451 26 281.055 26H263.955V23.66H280.407L284.115 18.008L259.923 13.436Z"
            fill="white"
          />
        </SecondTitle>

        <Language locale={locale} />
        <ColumnMobile>
          <b>{contacts[0].title}:</b>{' '}
          <a href={`mailto:${contacts[0].email}`}>{contacts[0].email}</a> //{' '}
          <a href={`tel:${contacts[0].phone}`}>{contacts[0].phone}</a>
        </ColumnMobile>
        <ColumnMobile second>
          <b>{contacts[1].title}:</b>{' '}
          <a href={`mailto:${contacts[1].email}`}>{contacts[1].email}</a>
        </ColumnMobile>
        <Row>
          <Column>
            <b>{contacts[0].title}</b>
            <br />
            <a href={`mailto:${contacts[0].email}`}>{contacts[0].email}</a>
            <br />
            <a href={`tel:${contacts[0].phone}`}>{contacts[0].phone}</a>
          </Column>
          <Column>
            <b>{contacts[1].title}</b>
            <br />
            <a href={`mailto:${contacts[1].email}`}>{contacts[1].email}</a>
          </Column>
        </Row>
        <div className="row">
          <div ref={this.left}>
            {paragraphs.map(({ begin, text, partners: havePartners }) => (
              <Paragraph key={begin}>
                <b>{begin}</b> {text}
                {havePartners && <Partners data={partners} allPartners={allPartners} />}
              </Paragraph>
            ))}
          </div>
          <Parallax
            offsetYMin="-30px"
            slowerScrollRate
            offsetYMax={`${this.state.offsetYMin}px`}
            className="work"
          >
            <div ref={this.right}>
              <Work labs data={work} />
              <svg
                className="brain"
                width="252"
                height="211"
                viewBox="0 0 252 211"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d)">
                  <path
                    d="M186.42 141.788C196.623 143.533 212.103 134.463 209.64 116.323C208.754 109.797 201.813 102.367 198.03 99.2299C192.049 94.2691 182.902 95.0439 182.902 95.0439"
                    stroke="#E91921"
                    strokeWidth="4"
                  />
                  <path
                    d="M60.1425 103.453C51.5645 109.095 46.5587 126.208 60.7409 137.782C65.8427 141.945 75.9462 142.665 80.8291 142.392C88.5495 141.96 94.6414 135.195 94.6414 135.195"
                    stroke="#E91921"
                    strokeWidth="4"
                  />
                  <path
                    d="M188.902 91C188.902 87.8615 188.832 81.236 184.342 77.0514C180.601 73.5642 177.327 72.2229 174.171 70.7745C171.014 69.326 162.245 61.4387 153.126 64.8463C144.006 68.2539 141.902 77.0514 141.902 82.6308"
                    stroke="#E91921"
                    strokeWidth="4"
                  />
                  <path
                    d="M143.955 58.8658C141.414 57.0216 136.008 53.1847 129.997 54.34C124.987 55.3027 121.989 57.1499 118.972 58.84C115.955 60.5301 104.445 62.9543 101.877 72.298C99.3082 81.6418 105.202 88.5056 109.72 91.7842"
                    stroke="#E91921"
                    strokeWidth="4"
                  />
                  <path
                    d="M98.9369 63.7307C95.944 62.7809 89.6048 60.8423 84.2636 63.8323C79.8125 66.3241 77.5485 69.0218 75.2175 71.5763C72.8864 74.1308 62.7268 80.0572 63.2324 89.7344C63.7381 99.4116 71.4942 104.069 76.8147 105.758"
                    stroke="#E91921"
                    strokeWidth="4"
                  />
                  <path
                    d="M89.052 147.641C91.1593 149.968 95.6598 154.835 101.78 154.942C106.88 155.031 110.195 153.84 113.495 152.807C116.795 151.774 128.557 151.77 132.994 143.155C137.43 134.54 133.075 126.61 129.329 122.472"
                    stroke="#E91921"
                    strokeWidth="4"
                  />
                  <path
                    d="M181.902 144.017C181.902 144.017 170.029 149.5 164.791 152.09C159.553 154.68 155.013 151.356 155.711 146.952C156.41 142.549 151.172 137.105 146.283 141.815C142.93 145.044 139.648 148.665 137.902 150.622"
                    stroke="#E91921"
                    strokeWidth="4"
                  />
                  <path
                    d="M174.902 122L175.387 120.06C174.673 119.881 173.919 120.109 173.424 120.653C172.928 121.196 172.771 121.968 173.015 122.662L174.902 122ZM180.649 132.338L176.789 121.338L173.015 122.662L176.874 133.662L180.649 132.338ZM174.417 123.94L194.417 128.94L195.387 125.06L175.387 120.06L174.417 123.94Z"
                    fill="#E91921"
                  />
                  <path
                    d="M154.412 84.8655L156.365 84.4331C156.206 83.7161 155.667 83.1438 154.961 82.9423C154.255 82.7408 153.495 82.9426 152.982 83.4678L154.412 84.8655ZM147.362 94.9436L155.843 86.2632L152.982 83.4678L144.5 92.1482L147.362 94.9436ZM152.459 85.298L156.905 105.375L160.811 104.51L156.365 84.4331L152.459 85.298Z"
                    fill="#E91921"
                  />
                  <path
                    d="M75.0972 88.1064L74.3807 86.2392C73.6951 86.5022 73.2088 87.1199 73.1139 87.8482C73.0191 88.5764 73.331 89.298 73.9264 89.7279L75.0972 88.1064ZM86.107 93.5892L76.268 86.485L73.9264 89.7279L83.7655 96.8322L86.107 93.5892ZM75.8136 89.9737L95.0122 82.6077L93.5794 78.8731L74.3807 86.2392L75.8136 89.9737Z"
                    fill="#E91921"
                  />
                  <path
                    d="M77.4258 133.452L75.8257 134.652C76.2662 135.239 76.9934 135.538 77.7198 135.43C78.4462 135.322 79.055 134.825 79.3057 134.135L77.4258 133.452ZM79.688 121.362L75.5459 132.769L79.3057 134.135L83.4478 122.728L79.688 121.362ZM79.0259 132.252L66.6896 115.8L63.4893 118.2L75.8257 134.652L79.0259 132.252Z"
                    fill="#E91921"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d"
                    x="0"
                    y="0"
                    width="252"
                    height="211"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="20" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.913725 0 0 0 0 0.0980392 0 0 0 0 0.129412 0 0 0 0.8 0"
                    />
                    <feBlend mode="lighten" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
              <svg
                className="flag"
                width="195"
                height="290"
                viewBox="0 0 195 290"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter1_d)">
                  <path d="M55 47.9998V170" stroke="#E91921" strokeWidth="4" />
                  <path
                    d="M42.5811 218.233L55.0953 179.979L100.286 223.797"
                    stroke="#E91921"
                    strokeWidth="4"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M93 237.621L113.162 223.015L153.486 244.576"
                    stroke="#E91921"
                    strokeWidth="4"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M126.533 60V85.0388"
                    stroke="#E91921"
                    strokeWidth="4"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M65.5887 55.8798C65.5887 55.8798 81.9201 47.8822 89.1197 44.1156C96.3194 40.3489 102.735 44.8265 101.904 50.9703C101.072 57.1141 108.526 64.5153 115.173 57.8139C119.731 53.2186 124.18 48.0815 126.545 45.3055"
                    stroke="#E91921"
                    strokeWidth="4"
                  />
                  <path
                    d="M65.5887 105.937C65.5887 105.937 81.9201 97.9394 89.1197 94.1727C96.3194 90.4061 102.735 94.8837 101.904 101.027C101.072 107.171 108.526 114.572 115.173 107.871C119.731 103.276 124.18 98.1386 126.545 95.3626"
                    stroke="#E91921"
                    strokeWidth="4"
                  />
                </g>
                <defs>
                  <filter
                    id="filter1_d"
                    x="0.680176"
                    y="0.733215"
                    width="193.749"
                    height="329.267"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="20" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.913725 0 0 0 0 0.0980392 0 0 0 0 0.129412 0 0 0 0.8 0"
                    />
                    <feBlend mode="lighten" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
          </Parallax>
        </div>
      </WrapperLabs>
    );
  }
}
